// auth_table/AuthTableGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTH_TABLE Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-10 11:53:27 using DbdbTap
 ************************************************ */

const AUTH_TABLE_LIST_PART = gql`
fragment AuthTableListPart on AuthTable {
    jobName
    authClassId
    jobComment
    allowUse
    regDate
    regUser
}
`;


export const LIST_AUTH_TABLE = gql`
${AUTH_TABLE_LIST_PART}
query ListAuthTable {
    authTableList {
        ...AuthTableListPart
    }
}
`;

export const GET_AUTH_TABLE = gql`
${AUTH_TABLE_LIST_PART}
query GetAuthTable($jobName:String!, $authClassId:String!) {
    authTableItem(jobName:$jobName, authClassId:$authClassId) {
        ...AuthTableListPart
    }
}
`;

export function makeAuthTableToTree(data) {
    // like {jobName: [authClassId1, authClassId2, .....]}
    let tree = {};
    for(const item of data) {
        if(item.allowUse) {
            if(!tree[item.jobName]) tree[item.jobName] = {allow:[], label: item.jobComment || '작업'};
            tree[item.jobName].allow.push(parseInt(item.authClassId));
        }
    }
    return tree;
}

